import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import InputComponentWrapper from './InputComponentWrapper';
import {isInputDataChanged} from 'src/js/containers/auto_layout/auto_layout_selectors';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

/* eslint-disable react/prefer-stateless-function */
class InputComponentWrapperContainer extends React.Component {
  render() {
    const {dataChanges, ...restProps} = this.props;
    return <InputComponentWrapper {...restProps} />;
  }
}

InputComponentWrapperContainer.displayName = 'InputComponentWrapperContainer';

InputComponentWrapperContainer.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  dataChanges: PropTypes.objectOf(PropTypes.any),
  dataSets: PropTypes.objectOf(PropTypes.any).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  rootData: PropTypes.objectOf(PropTypes.any).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  readOnly: PropTypes.bool,
  textOnly: PropTypes.bool,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
};

InputComponentWrapperContainer.defaultProps = {
  data: {},
  dataChanges: undefined,
  idSuffix: '',
  pathToData: '',
  readOnly: false,
  textOnly: false,
  expanded: false,
};

export default connect((state, props) => ({
  isChanged: isInputDataChanged(state, props),
}))(InputComponentWrapperContainer);
